import { createElement, ReactElement } from 'react'

export enum WidgetTypes {
    CHART = 'CHART',
    OI_CHART = 'OI_CHART',
    OPEN_INTEREST_CHART = 'OPEN_INTEREST_CHART',
    MULTI_STRIKE_CHART = 'MULTI_STRIKE_CHART',
    OPTION_CHAIN = 'OPTION_CHAIN',
    FUTURE_CHART = 'FUTURE_CHART',
    ATM_OPTION_CHART = 'ATM_OPTION_CHART',
    OPTION_CHART = "OPTION_CHART"
}

export const WidgetTypesNames: Record<WidgetTypes, string> = {
    [WidgetTypes.CHART]: 'Candle chart',
    [WidgetTypes.OI_CHART]: 'OI chart',
    [WidgetTypes.OPEN_INTEREST_CHART]: 'Open Interest',
    [WidgetTypes.MULTI_STRIKE_CHART]: 'Multi strike chart',
    [WidgetTypes.OPTION_CHAIN]: 'Option chain',
    [WidgetTypes.FUTURE_CHART]: 'Future chart',
    [WidgetTypes.ATM_OPTION_CHART]: 'ATM option chart',
    [WidgetTypes.OPTION_CHART]: 'Option chart',
}

export type WidgetOptionMenuItem = {
    id: string
    widgetType: WidgetTypes
    label: string
    multiStrikeChartType?: 'price' | 'iv' | 'oi' | 'oiChange' | 'straddle' | 'oiDiff' | 'pcr'
}

export const GLOBAL_WIDGET_OPTION_MENU_ITEMS: WidgetOptionMenuItem[] = [
    { id: 'chart', widgetType: WidgetTypes.CHART, label: 'Candle chart' },
    { id: 'open-interest', widgetType: WidgetTypes.OPEN_INTEREST_CHART, label: 'Open Interest' },
    { id: 'option-chain', widgetType: WidgetTypes.OPTION_CHAIN, label: 'Option chain' },
]

export const MULTI_STRIKE_WIDGET_OPTION_MENU_ITEMS: WidgetOptionMenuItem[] = [
    { id: 'ms-price', widgetType: WidgetTypes.MULTI_STRIKE_CHART, label: 'Price', multiStrikeChartType: 'price' },
    { id: 'ms-iv', widgetType: WidgetTypes.MULTI_STRIKE_CHART, label: 'Imp. Vol', multiStrikeChartType: 'iv' },
    { id: 'ms-oi', widgetType: WidgetTypes.MULTI_STRIKE_CHART, label: 'Open Int.', multiStrikeChartType: 'oi' },
    { id: 'ms-oi-change', widgetType: WidgetTypes.MULTI_STRIKE_CHART, label: 'OI Change', multiStrikeChartType: 'oiChange' },
    { id: 'ms-straddle', widgetType: WidgetTypes.MULTI_STRIKE_CHART, label: 'Straddle', multiStrikeChartType: 'straddle' },
    { id: 'ms-oi-diff', widgetType: WidgetTypes.MULTI_STRIKE_CHART, label: 'OI Diff', multiStrikeChartType: 'oiDiff' },
    { id: 'ms-pcr', widgetType: WidgetTypes.MULTI_STRIKE_CHART, label: 'PCR', multiStrikeChartType: 'pcr' },
]

export const WIDGET_OPTION_MENU_ITEMS: WidgetOptionMenuItem[] = [
    ...GLOBAL_WIDGET_OPTION_MENU_ITEMS,
    ...MULTI_STRIKE_WIDGET_OPTION_MENU_ITEMS,
]

export const WidgetTypeMap: Record<WidgetTypes, ReactElement> = {
    [WidgetTypes.CHART]: createElement('div'),
    [WidgetTypes.OI_CHART]: createElement('div'),
    [WidgetTypes.OPEN_INTEREST_CHART]: createElement('div'),
    [WidgetTypes.MULTI_STRIKE_CHART]: createElement('div'),
    [WidgetTypes.OPTION_CHAIN]: createElement('div'),
    [WidgetTypes.FUTURE_CHART]:createElement('div'),
    [WidgetTypes.ATM_OPTION_CHART]:createElement('div'),
    [WidgetTypes.OPTION_CHART]: createElement('div'),
}

export enum PredefinedDashboard {
    LAYOUT_1,
    LAYOUT_H2,
    LAYOUT_V2,
    LAYOUT_V3,
    LAYOUT_H3,
    LAYOUT_H2_2V2,
    LAYOUT_V2_1H2,
    LAYOUT_V2_2H2,
    LAYOUT_H2_1V2,
    LAYOUT_V4,
    LAYOUT_H4,
    LAYOUT_V2_2H3,
    LAYOUT_V2_1H2_2V2,
    LAYOUT_H2_2V3,
    LAYOUT_H2_1V3,
    LAYOUT_H2_1V2_2V2,
    LAYOUT_H2_1H2_2V2
}